<template>
  <section class="contacts-section" :style="{ backgroundImage: `url(${profileConfig.bg})` }">
    <Header />
    <div class="contacts-title" v-if="contactItems.length == 0">
      <router-link style="display: flex" :to="contactsProviderActivity"><i class="fas fa-user-friends"></i></router-link>
      <label>Contatos</label>
    </div>
    <div class="contacts-container" style="flex-direction: column" v-if="contactItems.length == 0">
      <span class="contacts-preview-container" style="font-size: 1.6rem">
        Você ainda não adicionou nenhum contato
        <router-link :to="contactsProviderActivity"><button class="button">NETWORK</button></router-link>
      </span>
    </div>
    <div class="contacts-title" v-if="contactItems.length != 0">
      <router-link title="Adicionar contatos" :to="contactsProviderActivity">
        <i class="fas fa-user-friends"></i>
        <label style="cursor: pointer">Contatos</label>
      </router-link>
      <span class="contacts-download-all-btn" title="Baixar lista de contatos" @click.prevent="downloadAllContacts()"><i class="fas fa-cloud-download-alt"></i></span>
    </div>
    <div class="contacts-container" v-if="contactItems.length != 0">
      <div class="contacts-preview-wrapper" v-if="selectedItem">
        <div class="contacts-preview-container">
          <h2 v-html="selectedItem.name"></h2>
          <span>{{ selectedItem.role }}</span>
          <img id="selectedItemImage" :src="selectedItem.image" :alt="selectedItem.item" />
          <div class="contacts-preview-container-btns">
            <button class="button" @click.prevent="openChannel" title="Enviar mensagem">MENSAGEM</button>
            <button class="button video-btn" @click.prevent="openBlitzarMeeting(selectedItem.user_id)" title="Chamada de vídeo"><i class="fas fa-video"></i></button>
            <div class="contacts-download-btn" title="Baixar contato" @click.prevent="downloadVCard(selectedItem.user_id)">
              <i class="fas fa-address-card"></i>
              <i class="fas fa-arrow-circle-down"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="contacts-list-wrapper">
        <div class="contacts-item-container" :class="{ selected: item.contact_id == selectedItem.contact_id }" v-for="item in contactItems" :key="item.contact_id" @click.prevent="itemClicked(item)">
          <div class="contacts-item-thumb">
            <img :id="item.contact_id" :src="item.thumbnail ? item.thumbnail : item.image" :alt="item.item" />
          </div>
          <div class="contacts-item-txts">
            <h2 v-html="item.name"></h2>
            <span v-html="item.role"></span>
            <span v-html="item.about_me"></span>
          </div>
          <div class="contacts-item-btns" @click.prevent="apiDeleteContact(item)">
            <i class="far fa-trash-alt" v-if="!item.isDeleting"></i>
            <SpinnerButton v-else />
          </div>
          <!-- <i class="fa fa-align-justify handle"></i> -->
        </div>
      </div>
    </div>
    <Footer style="position: fixed" />
    <Spinner :showSpinner="showSpinner" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import Spinner from '@/components/ui/Spinner.vue';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';
import api from '@/services/api';
import * as dayjs from 'dayjs';
import draggable from 'vuedraggable';
import vCardsJS from 'vcards-js';
import * as html2canvas from '@/services/html2canvas';

let blobOut = '';

export default {
  name: 'Contacts',
  components: { Header, Footer, draggable, Spinner, SpinnerButton },

  data() {
    return {
      vCard: null,
      dayjs: null,
      contactItems: [],
      profileConfig: null,
      selectedItem: null,
      isReordering: false,
      channelId: '',
      contactsProviderActivity: { name: 'Network', params: { stream: null } },
      showSpinner: false,
    };
  },

  beforeMount() {
    this.vCard = vCardsJS();
    this.dayjs = dayjs;
    this.profileConfig = this.$store.state.template.profileConfig;
    this.contactsProviderActivity = this.$store.state.template.userProfile.contactsProvider;
    this.apiGetContacts();
  },
  computed: {
    contactItemsComputed() {
      return this.contactItems.sort((a, b) => (a.order > b.order ? 1 : -1));
    },
    dragFieldOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    apiGetContacts() {
      api
        .get(`event/${this.$store.state.eventId}/contact`)
        .then((response) => {
          // console.log('get contacts response: ', { response });
          this.contactItems = response.data.map((item) => {
            item.isDeleting = false;
            item.isReordering = false;
            return item;
          });
          this.contactItems.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.selectedItem = this.contactItems[0];
        })
        .catch((err) => console.error(err));
    },
    apiPutContact(item) {
      let payload = {
        order: item.order,
      };
      api
        .put(`event/${this.$store.state.eventId}/contact/${item.contact_id}`, payload)
        .then((response) => {
          // console.log('put contact response: ', item.order, { response });
        })
        .catch((err) => console.error(err));
    },
    apiDeleteContact(item) {
      if (confirm('Remover Contato?')) {
        item.isDeleting = true;
        api
          .delete(`event/${this.$store.state.eventId}/contact/${item.contact_id}`)
          .then((response) => {
            item.isDeleting = false;
            this.contactItems = this.contactItems.filter((i) => i.contact_id != item.contact_id);
          })
          .catch((err) => console.error(err));
      } else item.isDeleting = false;
    },
    itemClicked(item) {
      this.selectedItem = item;
      this.vCard.firstName = this.selectedItem.name;
      this.vCard.organization = this.selectedItem.company;
    },
    handleOrdering(e) {
      this.isReordering = true;
      let contactItems = JSON.parse(JSON.stringify(this.contactItems));

      contactItems.map((item, n) => {
        item.order = n;
        this.contactItems.map((contact) => {
          if (item.contact_id == contact.contact_id) {
            contact.order = n;
            // console.log('SELECTED CONTACT: ', contact.name, contact.order, { contact });
            this.apiPutContact(contact);
          }
          return contact;
        });
      });

      this.$nextTick(() => {
        this.isReordering = false;
      });
    },
    openChannel() {
      // console.log('open channel selectedItem link', this.selectedItem.link);
      // this.channelId = this.selectedItem.link;

      api
        .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: this.selectedItem.contact_user_id, channelName: this.selectedItem.link })
        .then((response) => {
          // console.log('createTalkChannel', this.selectedItem.target, { response });
          if (response.data) {
            this.$root.$emit('openChannel', response.data.talk_channel_id);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openBlitzarMeeting(user_id) {
      console.log('openBlitzarMeeting', user_id);
      this.$nextTick(() => {
        api
          .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: user_id, channelName: user_id > this.$store.state.user.id ? user_id + this.$store.state.user.id : this.$store.state.user.id + user_id })
          .then(async (response) => {
            console.log('createTalkChannel', { response });
            if (response.data) {
              this.channelId = response.data.talk_channel_id;
              const invite = await this.sendInviteMessage(this.channelId);
              this.$nextTick(() => {
                if (invite && !this.$store.state.user.inMeeting) this.$root.$emit('joinBlitzarMeeting', this.channelId);
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },
    sendInviteMessage(channelID) {
      return new Promise((resolve, reject) => {
        api
          .post(`event/${this.$store.state.eventId}/sendMessageChannel`, {
            channel_id: channelID,
            message: `${this.$store.state.user.name} está te convidando para uma vídeo chamada. Clique para entrar.`,
            reactions: 'blitzar-meeting-invite',
          })
          .then((response) => {
            console.log('message sent', { response });
            // document.getElementById('messagesContainer').focus();
            // this.$root.$emit('openChannel', this.channelId);
            resolve(response);
          })
          .catch((err) => console.error(err));
      });
    },
    async downloadVCard(user_id) {
      const idx = this.contactItems.findIndex((item) => item.user_id == user_id);
      this.showSpinner = true;
      this.prepareVCards(idx).then((response) => {
        // console.log('DONE', { response });

        let fileName = `${this.selectedItem.name}.vcf`;
        let fileURL = window.URL.createObjectURL(new Blob([blobOut]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.showSpinner = false;
      });
    },

    prepareVCards(idx) {
      return new Promise((resolve, reject) => {
        const options = {
          type: 'dataURL',
          useCORS: true,
          allowTaint: false,
          logging: true,
          backgroundColor: 'transparent',
        };

        let count = 0;
        let contacts = this.contactItems;
        if (idx) contacts = [this.contactItems[idx]];
        contacts.map(async (contact) => {
          let img = document.getElementById(contact.contact_id);
          let imgOut = await html2canvas(img, options);

          contact.card = vCardsJS();
          contact.card.firstName = contact.name;
          contact.card.organization = contact.company;
          contact.card.photo.base64 = true;
          contact.card.photo.mediaType = 'PNG';
          contact.card.photo.url = imgOut.toDataURL().split(',').pop();

          // console.log(contact.card.getFormattedString());

          blobOut += contact.card.getFormattedString() + '\n';
          count++;
          // console.log(count, this.contactItems.length);
          if (count == this.contactItems.length) {
            // console.log('Resolve');
            resolve();
          }
        });
      });
    },

    downloadAllContacts() {
      this.showSpinner = true;
      setTimeout((_) => {
        this.prepareVCards().then((response) => {
          // console.log('DONE', { response });

          let fileName = `${'all_contacts'}.vcf`;
          let fileURL = window.URL.createObjectURL(new Blob([blobOut]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.showSpinner = false;
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.contacts-section {
  position: relative;
  color: var(--userProfile-textColor);
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100%;
  height: 100%;
  min-height: calc(100dvh);
  padding-top: 106px;

  display: flex;
  flex-direction: column;

  @include media('<=phone') {
    padding: 62px 0;
  }
}
.contacts-title {
  position: relative;
  width: max-content;
  font-size: 3rem;
  text-align: left;
  margin-left: 11%;
  padding: 6px 16px 6px 6px;
  border-radius: var(--userProfile-borderRadius);
  filter: brightness(0.8);
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }
  @include media('<=tablet') {
    margin-left: 30px;
  }
  @media (max-width: 860px) {
    margin-left: 20px;
  }
  @include media('<=phone') {
    margin-left: 2.3%;
  }
  display: flex;
  align-items: center;
  i {
    color: var(--userProfile-textColor);
    font-size: 2.3rem;
    margin-right: 10px;
    @include media('<=phone') {
      font-size: 2rem;
    }
  }
  label {
    font-size: 3rem;
    @include media('<=phone') {
      font-size: 2.3rem;
    }
  }
}
.contacts-container {
  position: relative;
  padding: 0 10% 120px 10%;

  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-start;

  @include media('<=tablet') {
    padding: 1% 2%;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 1% 2% 120px;
  }
  @include media('<=phone') {
    padding: 1% 0px;
  }
}
.contacts-download-all-btn {
  position: relative;
  margin-left: 10px;
  z-index: 1;
  cursor: pointer;
  transition: all 1s ease;
  // max-width: 100px;
  text-align: center;
  &:hover {
    transform: scale(1.1);
    color: var(--button-text);
    // background: var(--button-hover);
  }

  i {
    font-size: 1.6rem !important;
    filter: brightness(0.7);
    transition: all 1s ease;

    &:hover {
      filter: brightness(1);
    }
  }
}
.contacts-preview-wrapper {
  position: relative;
  width: 40%;
  min-height: 260px;
  flex-grow: 1;
  border-radius: var(--userProfile-borderRadius);
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  padding: 2%;

  display: flex;
  flex-wrap: wrap;

  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }
  @include media('<=tablet') {
    width: 100%;
    padding: 14px;
    border-top-left-radius: var(--userProfile-borderRadius);
    border-bottom-right-radius: unset;
  }
}
.contacts-preview-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  .button {
    cursor: pointer;
    position: relative;
    width: 100%;
    max-width: 500px;
    margin-top: 20px;
    padding: 10px;
    color: var(--userProfile-textColor);
    background: var(--userProfile-buttonBgColor);
    border-radius: calc(var(--userProfile-borderRadius) / 2);
    text-align: center;

    @include media('<=phone') {
      margin: 16px 0 0;
    }
  }

  h2 {
    position: relative;
    margin-bottom: 6px;
    font-size: 2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
  }
  span {
    position: relative;
    margin-bottom: 12px;
    filter: brightness(0.7);
  }
  img {
    position: relative;
    max-width: 100%;
    max-height: 378px;
    object-fit: contain;
    @include media('<=phone') {
      height: 240px;
    }
  }
  .contacts-preview-container-btns {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    @include media('<=tablet') {
      width: 100%;
      display: flex;
      justify-content: center;
      position: relative;
    }

    button {
      cursor: pointer;
      position: relative;
      width: 100%;
      // margin-top: 20px;
      padding: 10px;
      color: var(--userProfile-textColor);
      background: var(--userProfile-buttonBgColor);
      border-radius: calc(var(--userProfile-borderRadius) / 2);

      @include media('<=phone') {
        // margin: 16px 0 0;
      }
    }
    .video-btn {
      padding: 4px 10px;
      width: max-content;
    }
    .contacts-download-btn {
      position: relative;
      margin-left: 10px;
      padding: 4px;
      z-index: 1;
      cursor: pointer;
      transition: all 1s ease;
      text-align: center;
      color: var(--userProfile-textColor);
      // background: var(--userProfile-buttonBgColor);
      border-radius: calc(var(--userProfile-borderRadius) / 2);

      display: flex;

      i {
        font-size: 1.2rem !important;
        filter: brightness(0.8);
        transition: all 1s ease;
      }

      &:hover > i {
        transform: scale(1.1);

        filter: brightness(1);
      }
    }
  }
}
.contacts-list-wrapper {
  position: relative;
  width: 60%;
  flex-grow: 1;
  height: calc(92vh - 240px);
  padding: 2%;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: var(--userProfile-borderRadius);
  border-top-right-radius: unset;
  user-select: none;

  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }
  @media (max-width: 860px) {
    width: 100%;
    padding: 14px;
    border-top-right-radius: var(--userProfile-borderRadius);
  }
  @include media('<=phone') {
    padding: 0 14px;
  }
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
  }
}
.contacts-item-container.selected {
  background: var(--userProfile-buttonBgColor);
  color: var(--userProfile-buttonTextColor);
  // filter: hue-rotate(180deg);

  .handle {
    filter: brightness(1);
  }
  .contacts-item-btns i {
    filter: brightness(1);
  }
}
.contacts-item-container {
  cursor: pointer;
  position: relative;
  width: 100%;
  min-height: 76px;
  padding: 12px;
  margin: 0 0 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: var(--userProfile-middleBgColor);
  border-radius: calc(var(--userProfile-borderRadius) / 2);
  &:active {
    transform: scale(0.99);
  }

  img {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 0 16px 0 0;
    object-fit: cover;
    object-position: top;
    border-radius: 50%;
  }
  .contacts-item-thumb {
    position: relative;
  }
  .contacts-item-txts {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    @include media('<=phone') {
      max-width: 42vw;
    }

    h2 {
      position: relative;
      width: 100%;
      text-transform: capitalize;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span {
      position: relative;
      filter: brightness(0.8);
    }
  }
  .contacts-item-btns {
    position: relative;
    height: 100%;
    margin-left: auto;
    margin-right: 4px;
    display: flex;
    align-items: center;
    transition: all 200ms ease-in-out;
    i {
      filter: brightness(0.6);

      &:hover {
        transform: scale(1.3);
        filter: brightness(1);
      }
    }
  }
  .handle {
    position: relative;
    font-size: 24px;
    margin: auto 4px auto 14px;
    transition: all 100ms ease-in-out;
    transform: scaleY(1.1);
    filter: brightness(0.6);
    &:hover {
      transform: scale(1.3);
      filter: brightness(1);
    }
  }
}
</style>
